import React from 'react';
import './Achievements.css';

// New Changes

const Achievements = () => {
  return (
    <div className="achievements-container">
      <div className="achievements-header">
        <h2>Our Achievements</h2>
        <p>Years of excellence and trusted partnerships</p>
      </div>
      
      <div className="achievements-grid">
        <div className="achievement-card">
          <div className="achievement-number">125+</div>
          <div className="achievement-title">Projects</div>
          <div className="achievement-description">Successfully delivered</div>
        </div>
        
        <div className="achievement-card">
          <div className="achievement-number">90+</div>
          <div className="achievement-title">Customers</div>
          <div className="achievement-description">Satisfied clients worldwide</div>
        </div>
        
        <div className="achievement-card">
          <div className="achievement-number">32+</div>
          <div className="achievement-title">Partners</div>
          <div className="achievement-description">Trusted collaborations</div>
        </div>
        
        <div className="achievement-card">
          <div className="achievement-number">10+</div>
          <div className="achievement-title">Years</div>
          <div className="achievement-description">Of experience</div>
        </div>
      </div>
    </div>
  );
};

export default Achievements;